import React from "react";
import { IListViewField } from "src/components/Shared/ILIstViewField";
import { IListViewCreateDependedDocumentAction } from "src/components/Shared/IListViewCreateDependedDocumentAction";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { ListviewToolbarSubmenuButton } from "src/components/Shared/ListViews/ListviewToolbarSubmenuButton";
import { AppEntities } from "src/config/entities";

const CustomerInvoicesList = () => {
  const fields: IListViewField[] = [
    {
      fieldName: "companyName",
      title: "Company"
    },
    {
      fieldName: "customerName",
      title: "Customer"
    },
    {
      fieldName: "warehouseName",
      title: "Warehouse"
    },
    {
      fieldName: "divisionName",
      title: "Division"
    },
    {
      fieldName: "currencyName",
      title: "Currency"
    },
    {
      fieldName: "commodityWaybillNo",
      title: "RS No"
    }
  ];

  const createReturnOfGoodsFromCustomers = async (data: any) => {
    try {
      const dataService = AppEntities.ReturnOfGoodsFromCustomers.getDataService();
      return await dataService.createBasedAtOrder(data.id);
    } catch (err) {
      console.log("data", data);
      console.log("error with", err);
    }
  };

  const createDocumentActions: IListViewCreateDependedDocumentAction[] = [
    {
      title: "Return Of Goods From Customer",
      appEntity: AppEntities.ReturnOfGoodsFromCustomers,
      createBaseAtFunction: createReturnOfGoodsFromCustomers
    }
  ];

  return (
    <>
      <ListView
        createDocumentActions={createDocumentActions}
        fields={fields}
        entity={AppEntities.CustomerInvoices}
        createDependedDocumentActions={createDocumentActions}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons>
            <ListviewToolbarSubmenuButton />
          </DocumentListViewDefaultToolbarButtons>
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default CustomerInvoicesList;
